<template>
  <div class="container">
    <div class="row">
        <div class="col-xs-12 text-center" style="margin:3rem 0;">
            <h3>FAQ</h3>
        </div>

        <div class="col-xs-12 text-center" style="margin-bottom:3rem;">
            <div class="accordion" id="runaccordion">
                <div class="accordion-item" v-for="faqsdata in faqsdatas" v-bind:key="faqsdata">
                    <h2 class="accordion-header" :id="'faq'+faqsdata.number">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse'+faqsdata.number" aria-expanded="false" :aria-controls="'collapse'+faqsdata.number">
                        <b>{{ faqsdata.Q }}</b>
                    </button>
                    </h2>
                    <div :id="'collapse'+faqsdata.number" class="accordion-collapse collapse" :aria-labelledby="'faq'+faqsdata.number" data-bs-parent="#runaccordion">
                        <div class="accordion-body bg-dark text-white" style="text-align:left;">
                            {{ faqsdata.A }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import * as CONFIG from '@/config.js'
export default {
    mounted() {
        document.title = 'FAQ'
        window.scrollTo(0,0)
    },
    data() {
        return{
            
            faqsdatas:[
            {
                number: 1,
                Q:'Apakah kepanjangan Sijakon ?',
                A:'Sistem Informasi Jasa Konstruksi'
            },
            {
                number: 2,
                Q:'Untuk siapa Sijakon ?',
                A:'Masyarakat dan Tukang'
            },
            {
                number: 3,
                Q:'Bagaiamana cara memesan Tukang ?',
                A:'Download dan install aplikasi mobile Sijakon, buat akun dan cari tukang sesuai kebutuhan dan kualifikasinya. Klik tombol Pesan, selanjutnya tukang akan merespon pesanan anda. Dengan begitu anda dapat langsung menegosiasikan kebutuhan '
            },
            {
                number: 4,
                Q:'Apakah Tukang di sini dapat dipercaya ?',
                A:'Ya, karena memiliki sertfikasi keahlian dari lembaga nasional resmi dan diawasi Pemerintah Kota Batam'
            },
            {
                number: 5,
                Q:'Apa saja platftorm aplikasi mobile nya ?',
                A:'Android yang tersedia untuk saat ini, sementara iOS masih dalam wacana pengembangan tahun 2022'
            },
            {
                number: 6,
                Q:'Bagaimana jika terjadi konflik dengan tukang ?',
                A:'Dapat menghubungi Dinas Cipta Karya dan Tata Ruang Bidang Bina Konstruksi Kota Batam, agar mendapatkan mediasi dan pembinaan antar keduanya.'
            },
            {
                number: 7,
                Q:'Apakah bisa mendaftar untuk Luar Batam ?',
                A:'Tidak Bisa. Hanya tukang yang terverifikasi sesuai lokasi di Batam dan memiliki keahlian yang dapat mendaftar secara legal.'
            },
            {
                number: 8,
                Q:'Apakah ada biaya pemesanan ?',
                A:'Biaya dinegosiasikan secara langsung oleh kedua belah pihak, yaitu Pengguna (Masyarakat) dengan Tukang dan tanpa perantara'
            },
            {
                number: 9,
                Q:'Aplikasi tidak bisa diinstall ?',
                A:'Pastikan Platform versi Android minimal 8 ke atas'
            },
            {
                number: 10,
                Q:'Ingin bertanya lebih lanjut ?',
                A:'Hubungi via whatsapp ke Pelayanan Dinas CIPTAKARU Pemerintah Kota Batam'
            }
          ],
        }
    },
    methods: {
        urldata() {
        // console.log(CONFIG.BASE_URL);
        },
    },
}
</script>